module.exports = __webpack_public_path__ + "img/reject.397e6f99.svg";